import { useCallback } from 'react'
import { useMenuCartStore, type MenuCartLine } from '@stores/menuCartStore'
import { getMenuCartLineTotal } from '@stores/menuCartStore'

export const useMenuCart = (slug?: string) => {
    const carts = useMenuCartStore((state) => state.carts)
    const addLineStore = useMenuCartStore((state) => state.addLine)
    const updateCantidadStore = useMenuCartStore((state) => state.updateCantidad)
    const removeLineStore = useMenuCartStore((state) => state.removeLine)
    const clearCartStore = useMenuCartStore((state) => state.clearCart)

    const safeSlug = slug ?? ''
    const lines: MenuCartLine[] = carts[safeSlug] ?? []
    const itemCount = lines.reduce((sum, line) => sum + line.cantidad, 0)
    const subtotal = lines.reduce((sum, line) => sum + getMenuCartLineTotal(line), 0)

    const addLine = useCallback(
        (line: Parameters<typeof addLineStore>[1]) => {
            if (!safeSlug) return
            addLineStore(safeSlug, line)
        },
        [safeSlug, addLineStore]
    )

    const updateCantidad = useCallback(
        (lineKey: string, cantidad: number) => {
            if (!safeSlug) return
            updateCantidadStore(safeSlug, lineKey, cantidad)
        },
        [safeSlug, updateCantidadStore]
    )

    const removeLine = useCallback(
        (lineKey: string) => {
            if (!safeSlug) return
            removeLineStore(safeSlug, lineKey)
        },
        [safeSlug, removeLineStore]
    )

    const clearCart = useCallback(() => {
        if (!safeSlug) return
        clearCartStore(safeSlug)
    }, [safeSlug, clearCartStore])

    return {
        lines,
        itemCount,
        subtotal,
        addLine,
        updateCantidad,
        removeLine,
        clearCart,
    }
}
